import TableTitleBar from "./TableTitleBar";

export default TableTitleBar;
